import './i18n/config';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import {
  ErrorBoundary,
  AuthProvider,
  buildOktaConfigFromWindow,
  loadCadConfig,
} from '@certara/common-react-components';

import App from './App';
import { theme } from './theme';

import { initializeApp } from './lib/initialize';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      refetchOnMount: 'always',
      refetchOnReconnect: 'always',
    },
  },
});

async function bootstrap() {
  // Await the CAD config fetch before mounting so auth-provider selection
  // (Okta vs CAD) sees the real `enabled` flag on first render.
  await loadCadConfig();

  initializeApp();

  ReactDOM.createRoot(document.getElementById('app')!).render(
    <React.StrictMode>
      <ErrorBoundary>
        <BrowserRouter
          basename={window.baseUrl || '/'}
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <AuthProvider oktaConfig={buildOktaConfigFromWindow()}>
            <QueryClientProvider client={queryClient}>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <App />
              </ThemeProvider>
            </QueryClientProvider>
          </AuthProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </React.StrictMode>
  );
}

bootstrap();
